import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import img1 from "../../assets/images/log0.png";
import img2 from "../../assets/images/log1 (1).png";
import img3 from "../../assets/images/log2.png";

const LogoDesignGridSection = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white "
      }`}
    >
      <section
        className={`relative mx-auto flex justify-center items-center py-5 md:py-20 px-6 md:px-20 transition-all duration-500`}
      >
        <div className="w-full max-w-[1536px]">
          <h2
            className={`text-center bricolage-grotesque-bold text-4xl md:text-5xl font-bold mb-5 md:mb-28 ${
              theme === "dark" ? "text-black" : "text-white"
            }`}
          >
            Logo Design
          </h2>

          <div
            className={`relative z-10 rounded-3xl px-6 md:px-20 py-5 md:py-16 transition-all duration-500  ${
              theme === "dark"
                ? "bg-white  shadow-[0_-30px_60px_-10px_rgba(141,25,218,0.5),0_30px_60px_-10px_rgba(141,25,218,0.5),0_0_25px_-5px_rgba(141,25,218,0.4)] md:shadow-[0_-60px_120px_-20px_rgba(141,25,218,1),0_60px_120px_-20px_rgba(141,25,218,1),0_0_50px_-10px_rgba(141,25,218,0.6)]"
                : "bg-black/90 shadow-[0_-30px_60px_-10px_rgba(141,25,218,0.5),0_30px_60px_-10px_rgba(141,25,218,0.5),0_0_25px_-5px_rgba(141,25,218,0.4)] md:shadow-[0_-60px_120px_-20px_rgba(141,25,218,1),0_60px_120px_-20px_rgba(141,25,218,1),0_0_50px_-10px_rgba(141,25,218,0.6)]"
            }`}
          >
            {/* 🧱 Equal Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch">
              {/* Text Card */}
     {/* Text Card (first div in the grid) */}
<div
  className={`rounded-2xl border-2 p-4 flex flex-col justify-between transition-all duration-500 
  ${theme === "dark" ? "bg-white border-gray-300" : "bg-black border-[#8D19DA]"}
  max-w-full mx-auto
  sm:p-6 md:p-8
  h-auto min-h-[220px]`}
>
  <div>
    <h3
      className={`text-2xl bricolage-grotesque-semibold sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 md:mb-4 ${
        theme === "dark" ? "text-black" : "text-white"
      }`}
    >
      Culinary Construction
    </h3>

       <p
                    className={`text-lg mb-6 ${
                      theme === "dark" ? "text-gray-700" : "text-gray-300 montserrat-regular"
                    }`}
                  >
                    Culinary Construct is a Vancouver-based design/build firm
                    specializing in commercial kitchens and bars. We offer
                    tailored solutions, expert project management, and trusted
                    vendor relationships to deliver efficient, high-quality
                    spaces.
                  </p>
  </div>

  <div className="flex flex-wrap gap-4 sm:gap-6 mt-auto">
    <div>
      <h4 className="font-bold mb-2 px-4 py-2 bg-[#0048B4] rounded-2xl text-[#00DE00] montserrat-regular ">
        Color Palette
      </h4>
      <div className="flex gap-1 sm:gap-2 px-2">
        <div className="w-7 h-4 sm:w-8 sm:h-5 bg-[#232323]" />
        <div className="w-7 h-4 sm:w-8 sm:h-5 bg-[#00DE00]" />
        <div className="w-7 h-4 sm:w-8 sm:h-5 bg-[#0048B4]" />
      </div>
    </div>

    <div>
      <h4 className="font-bold mb-2 px-5 py-2 bg-[#0048B4] rounded-2xl text-[#00DE00] inline-block montserrat-regular">
        Typography
      </h4>
      <p
        className={`text-[10px] sm:text-xs md:text-sm montserrat-regular ${
          theme === "dark" ? "text-gray-600" : "text-gray-400"
        }`}
      >
        Aileron
        <br />
        ABCDEFGHIJKLMNOPQRSTUVWXYZ
        <br />
        abcdefghijklmnopqrstuvwxyz
      </p>
    </div>
  </div>
</div>




              {/* Image 1 */}
              <div
                className={`rounded-2xl border-2 overflow-hidden flex items-center justify-center h-full transition-all duration-500 ${
                  theme === "dark" ? "border-gray-300" : "border-[#8D19DA]"
                }`}
              >
                <img
                  src={img1}
                  alt="Culinary Construct Logo"
                  className="w-full h-[150px] md:h-full object-contain transition-transform duration-500 ease-in-out group-hover:scale-105 bg-black"
                />
              </div>

              {/* Image 2 */}
              <div
                className={`rounded-2xl border-2 overflow-hidden flex items-center justify-center h-full transition-all duration-500 ${
                  theme === "dark" ? "border-gray-300" : "border-[#8D19DA]"
                }`}
              >
                <img
                  src={img2}
                  alt="Business Card Mockup"
                  className="w-full h-full object-contain transition-transform duration-500 ease-in-out group-hover:scale-105"
                />
              </div>

              {/* Image 3 */}
              <div
                className={`rounded-2xl border-2 overflow-hidden flex items-center justify-center h-full transition-all duration-500 bg-black ${
                  theme === "dark" ? "border-gray-300" : "border-[#8D19DA]"
                }`}
              >
                <img
                  src={img3}
                  alt="Logo Mockup"
                  className="w-full h-full object-contain transition-transform duration-500 ease-in-out group-hover:scale-105"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LogoDesignGridSection;
